<template>
  <div class="row">
    <div class="col-12 g">
        <div class="card card-body">
            <div class="table-responsive col-12">
                <table class="table table-hover table-bordered">
                    <thead>
                        <th>
                            الطالب
                        </th>
                        <th>
                            الفصل
                        </th>
                        <th>
                            توقيت الانصراف
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="log in logs" :key="log._id">
                            <td>
                                <img :src="student(log.number).image" v-if="student(log.number).image" style="width: 70px; height: 70px; border-radius: 10px">
                                {{ student(log.number).name }}
                            </td>
                            <td>
                                {{ student(log.number).classname }} - {{ student(log.number).classroom }}
                            </td>
                            <td v-if="log.time.split(' ').length > 1">
                                {{ log.time.split(" ")[1] }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            students: {},
            logs: [],
            interval: null
        }
    },
    beforeDestroy(){
        if(this.interval){
            clearInterval(this.interval)
        }
    },
    created(){
        if(!checkPer("students|scan|ends")){
            this.$router.push('/NotPermitted')
            return false;
        }
        var g = this;
        $.post(api + '/user/students/list', {
            jwt: this.user.jwt,
            page: 1,
            perpage: 10000
        }).then(function(r){
            g.loading = false
            if(r.status != 100){
                alert(r.response)
            }else{
                r.response.forEach(function(a){
                    g.students[a.number] = a
                })
                g.getLogs()
            }
        }).fail(function(){
        
        })
        this.interval = setInterval(() => {
            g.getLogs()
        }, 5000);
    },
    methods: {
        getLogs(){
             var g = this;
            $.post(api + '/user/students/reports/ends', {
                jwt: this.user.jwt
            }).then(function(r){
                g.logs = r.response
            })
        },
        student(number){
            if(this.students[number]){
                return this.students[number];
            }
            return {};
        }
    }
}
</script>

<style>

</style>